/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type or paste text to convert…`)
};

const es_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe o pega texto para convertir…`)
};

const de_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text eingeben oder einfügen zum Konvertieren…`)
};

const nl_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ of plak tekst om om te zetten…`)
};

const fr_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez ou collez le texte à convertir…`)
};

const it_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita o incolla il testo da convertire…`)
};

const pt_br2_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole o texto para converter…`)
};

const pt_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole o texto para converter…`)
};

const ja_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換するテキストを入力または貼り付けてください…`)
};

const zh_cc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入或粘贴要转换的文本……`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_placeholder", locale)
	if (locale === "en") return en_cc_placeholder(inputs)
	if (locale === "es") return es_cc_placeholder(inputs)
	if (locale === "de") return de_cc_placeholder(inputs)
	if (locale === "nl") return nl_cc_placeholder(inputs)
	if (locale === "fr") return fr_cc_placeholder(inputs)
	if (locale === "it") return it_cc_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_cc_placeholder(inputs)
	if (locale === "pt") return pt_cc_placeholder(inputs)
	if (locale === "ja") return ja_cc_placeholder(inputs)
	return zh_cc_placeholder(inputs)
};